module.exports = __webpack_public_path__ + "assets/img/6_464.22cc0323.jpg";